import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import alertActions from '../../actions/alert.actions';
import AlertDispatch from '../../contexts/alert.dispatch';
import checkMarkImg from '../../images/check-mark-active.svg';
import closeImg from '../../images/dark-close.svg';
import errorIcon from '../../images/icons/icon-error.svg';

import style from './Alert.module.css';

const Alert = React.memo(({ sucessMessage = '', errorMessage = '' }) => {
  const dispatch = useContext(AlertDispatch);

  useEffect(() => {
    if (sucessMessage || errorMessage) {
      setTimeout(() => {
        dispatch({
          type: alertActions.CLEAR,
        });
      }, 5000);
    }
  }, [sucessMessage, errorMessage, dispatch]);

  const handleCloseAlert = () => {
    dispatch({
      type: alertActions.CLEAR,
    });
  };

  return (
    <>
      {sucessMessage && (
        <div className={style.successAlert}>
          <img className={style.checkMark} src={checkMarkImg} alt="" />
          {sucessMessage}
          <button
            className={style.closeBtn}
            type="button"
            onClick={handleCloseAlert}
          >
            <img src={closeImg} alt="" />
          </button>
        </div>
      )}
      {errorMessage && (
        <div className={style.errorAlert}>
          <img className={style.errorMark} src={errorIcon} alt="" />
          {errorMessage}
          <button
            className={style.closeBtn}
            type="button"
            onClick={handleCloseAlert}
          >
            <img src={closeImg} alt="" />
          </button>
        </div>
      )}
    </>
  );
});

Alert.propTypes = {
  sucessMessage: PropTypes.string,
  errorMessage: PropTypes.string,
};

export default Alert;
